import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';
import './Projects.css';

const Projects = () => {
    useEffect(() => {
        // Force hide spinner immediately
        const spinner = document.getElementById('spinner');
        if (spinner) {
            spinner.classList.remove('show');
            spinner.style.display = 'none';
            spinner.style.opacity = '0';
            spinner.style.visibility = 'hidden';
        }
        if (window.WOW) {
            new window.WOW().init();
        }

        const $ = window.$;
        if ($) {
            // ── Mobile Owl Carousel (only on small screens) ──
            let mobileOwl;
            if ($.fn.owlCarousel) {
                mobileOwl = $('#projCarouselMobile').owlCarousel({
                    loop: true,
                    items: 1,
                    margin: 10,
                    nav: false,
                    dots: true,
                    autoplay: true,
                    autoplayTimeout: 3200,
                    autoplayHoverPause: true,
                    smartSpeed: 550
                });
            }

            // ── Filter Tabs ──
            $('.tab-btn').off('click').on('click', function () {
                var target = $(this).data('pane');
                $('.tab-btn').removeClass('active');
                $(this).addClass('active');
                $('.sec-pane').removeClass('active-pane').hide();
                $('#' + target).addClass('active-pane').show();

                // Refresh carousel when returning to projects on mobile
                if (target === 'pane-projects' && mobileOwl && mobileOwl.trigger) {
                    mobileOwl.trigger('refresh.owl.carousel');
                }
            });
        }
    }, []);

    return (
        <>
            <WhatsAppFloat />
            <Navbar />

            {/* Page Header Start (original WebBears style) */}
            <div className="container-fluid page-header mb-5 wow fadeIn" data-wow-delay="0.1s">
                <div className="container">
                    <h1 className="display-3 mb-4 animated slideInDown">Our Projects</h1>
                    <nav aria-label="breadcrumb animated slideInDown">
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item"><a href="/">Home</a></li>
                            <li className="breadcrumb-item"><a href="/project">Pages</a></li>
                            <li className="breadcrumb-item active" aria-current="page">Projects</li>
                        </ol>
                    </nav>
                </div>
            </div>
            {/* Page Header End */}

            {/* ══ MAIN CONTENT ══════════════════════════ */}
            <div className="container-xxl py-5">
                <div className="container">

                    {/* ── WHAT WE DELIVER ──────────────────── */}
                    <div className="deliver-strip wow fadeInUp" data-wow-delay="0.1s">
                        <div className="ds-eyebrow">What We Do</div>
                        <h2>Full-Stack Digital Services<br />Under One Roof</h2>
                        <p className="ds-sub">From websites to viral reels — everything we deliver for our clients.</p>
                        <div className="ds-grid">
                            <div className="ds-tile">
                                <div className="ds-icon"><i className="fa fa-laptop-code"></i></div>
                                <h5>Web Development</h5>
                                <p>Custom sites built for speed, SEO &amp; conversions.</p>
                            </div>
                            <div className="ds-tile">
                                <div className="ds-icon"><i className="fa fa-shopping-cart"></i></div>
                                <h5>E-Commerce</h5>
                                <p>Full online stores with payments &amp; inventory.</p>
                            </div>
                            <div className="ds-tile">
                                <div className="ds-icon"><i className="fa fa-chart-line"></i></div>
                                <h5>SMM &amp; Growth</h5>
                                <p>Content, reels &amp; ads that grow your brand.</p>
                            </div>
                            <div className="ds-tile">
                                <div className="ds-icon"><i className="fa fa-film"></i></div>
                                <h5>Video Editing</h5>
                                <p>Reels, promos &amp; testimonials that convert.</p>
                            </div>
                            <div className="ds-tile">
                                <div className="ds-icon"><i className="fa fa-paint-brush"></i></div>
                                <h5>Graphic Design</h5>
                                <p>Brand kits, creatives &amp; banners that stand out.</p>
                            </div>
                            <div className="ds-tile">
                                <div className="ds-icon"><i className="fa fa-server"></i></div>
                                <h5>IT Consulting</h5>
                                <p>Cloud, security &amp; digital strategy for growth.</p>
                            </div>
                        </div>
                    </div>

                    {/* ── NUMBERS ──────────────────────────── */}
                    <div className="nums-strip wow fadeInUp" data-wow-delay="0.1s">
                        <div className="ns-item">
                            <div className="ns-num">50+</div>
                            <div className="ns-lbl">Projects Delivered</div>
                        </div>
                        <div className="ns-item">
                            <div className="ns-num">40+</div>
                            <div className="ns-lbl">Happy Clients</div>
                        </div>
                        <div className="ns-item">
                            <div className="ns-num">3x</div>
                            <div className="ns-lbl">Avg Social Growth</div>
                        </div>
                        <div className="ns-item">
                            <div className="ns-num">5★</div>
                            <div className="ns-lbl">Client Rating</div>
                        </div>
                    </div>

                    {/* ── SECTION TITLE ────────────────────── */}
                    <div className="text-center mx-auto wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: '600px', marginBottom: '18px' }}>
                        <p className="d-inline-block border rounded text-primary fw-semi-bold py-1 px-3">Our Work</p>
                        <h1 className="display-5 mb-4">We Have Completed Latest Projects</h1>
                    </div>

                    {/* ── FILTER TABS ──────────────────────── */}
                    <div className="tab-row wow fadeInUp" data-wow-delay="0.2s">
                        <button className="tab-btn active" data-pane="pane-projects"><i className="fa fa-globe"></i> Web Projects</button>
                        <button className="tab-btn" data-pane="pane-smm"><i className="fab fa-instagram"></i> SMM &amp; Growth</button>
                        <button className="tab-btn" data-pane="pane-videos"><i className="fa fa-play-circle"></i> Video Edits</button>
                        <button className="tab-btn" data-pane="pane-testimonials"><i className="fa fa-star"></i> Testimonials</button>
                        <button className="tab-btn" data-pane="pane-gallery"><i className="fa fa-images"></i> Gallery</button>
                    </div>

                    {/* ════════════════════════════════════════
                   PANE 1 – WEB PROJECTS
                   Desktop: Bootstrap row/col grid
                   Mobile : Owl Carousel
              ════════════════════════════════════════ */}
                    <div id="pane-projects" className="sec-pane active-pane">

                        {/* DESKTOP GRID (hidden on mobile) */}
                        <div className="d-none d-md-block">
                            <div className="row g-4">
                                <div className="col-md-4 wow fadeInUp" data-wow-delay="0.1s">
                                    <div className="proj-card">
                                        <div className="proj-img">
                                            <span className="proj-cat">E-Commerce</span>
                                            <img src="img/projects/BharatiyaBazaar.png" alt="BharatiyaBazaar" />
                                            <div className="proj-overlay"><a href="http://www.bharatiyabazaar.com" target="_blank" rel="noreferrer"><i className="fa fa-external-link-alt"></i> Visit Site</a></div>
                                        </div>
                                        <div className="proj-body">
                                            <h4>BharatiyaBazaar</h4>
                                            <p>Full e-commerce platform for traditional Indian products with payment integration &amp; product catalog.</p>
                                            <div className="tech-tags"><span className="tech-tag">E-Commerce</span><span className="tech-tag">UI/UX</span><span className="tech-tag">Payment Gateway</span></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay="0.15s">
                                    <div className="proj-card">
                                        <div className="proj-img">
                                            <span className="proj-cat">Food &amp; Resto</span>
                                            <img src="img/projects/allaboutfood.jpg" alt="All About Foods" />
                                            <div className="proj-overlay"><a href="http://www.allaboutfoods.in" target="_blank" rel="noreferrer"><i className="fa fa-external-link-alt"></i> Visit Site</a></div>
                                        </div>
                                        <div className="proj-body">
                                            <h4>All About Foods</h4>
                                            <p>Restaurant &amp; food discovery website with menu management, SEO &amp; mobile-first responsive design.</p>
                                            <div className="tech-tags"><span className="tech-tag">Website</span><span className="tech-tag">SEO</span><span className="tech-tag">Responsive</span></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay="0.2s">
                                    <div className="proj-card">
                                        <div className="proj-img">
                                            <span className="proj-cat">Corporate</span>
                                            <img src="img/projects/MSPL.jpg" alt="MSPL" />
                                            <div className="proj-overlay"><a href="https://mspl-v0-1.vercel.app/" target="_blank" rel="noreferrer"><i className="fa fa-external-link-alt"></i> Visit Site</a></div>
                                        </div>
                                        <div className="proj-body">
                                            <h4>MSPL</h4>
                                            <p>Corporate website for a manufacturing firm — clean professional design with full service showcase.</p>
                                            <div className="tech-tags"><span className="tech-tag">Corporate</span><span className="tech-tag">Web Design</span><span className="tech-tag">Branding</span></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay="0.25s">
                                    <div className="proj-card">
                                        <div className="proj-img">
                                            <span className="proj-cat">Tech Services</span>
                                            <img src="img/projects/PCreviver.jpg" alt="PC Reviver" />
                                            <div className="proj-overlay"><a href="https://www.pcreviver.in" target="_blank" rel="noreferrer"><i className="fa fa-external-link-alt"></i> Visit Site</a></div>
                                        </div>
                                        <div className="proj-body">
                                            <h4>PC Reviver</h4>
                                            <p>Tech repair service website with service listings, booking flow &amp; local SEO for Thane region.</p>
                                            <div className="tech-tags"><span className="tech-tag">Service Site</span><span className="tech-tag">Local SEO</span><span className="tech-tag">Booking</span></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay="0.3s">
                                    <div className="proj-card">
                                        <div className="proj-img">
                                            <span className="proj-cat">E-Commerce</span>
                                            <img src="img/projects/Grabit.png" alt="iGRABiT" />
                                            <div className="proj-overlay"><a href="http://www.igrabit.store" target="_blank" rel="noreferrer"><i className="fa fa-external-link-alt"></i> Visit Site</a></div>
                                        </div>
                                        <div className="proj-body">
                                            <h4>iGRABiT</h4>
                                            <p>Online product store with category management, cart system &amp; mobile-first responsive design.</p>
                                            <div className="tech-tags"><span className="tech-tag">E-Commerce</span><span className="tech-tag">Mobile-First</span><span className="tech-tag">UI/UX</span></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 wow fadeInUp" data-wow-delay="0.35s">
                                    <div className="proj-placeholder">
                                        <div className="ph-icon"><i className="fa fa-plus"></i></div>
                                        <h5>Your Project Next?</h5>
                                        <p>Let's build something amazing together.</p>
                                        <a href="/contact" className="btn btn-primary rounded-pill px-4" style={{ background: 'var(--wb-primary)', borderColor: 'var(--wb-primary)' }}>Get Started</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* MOBILE CAROUSEL (hidden on desktop) */}
                        <div className="d-block d-md-none">
                            <div className="owl-carousel" id="projCarouselMobile">
                                <div className="proj-card mx-1">
                                    <div className="proj-img">
                                        <span className="proj-cat">E-Commerce</span>
                                        <img src="img/projects/BharatiyaBazaar.png" alt="BharatiyaBazaar" />
                                        <div className="proj-overlay"><a href="http://www.bharatiyabazaar.com" target="_blank" rel="noreferrer"><i className="fa fa-external-link-alt"></i> Visit Site</a></div>
                                    </div>
                                    <div className="proj-body">
                                        <h4>BharatiyaBazaar</h4>
                                        <p>Full e-commerce platform for traditional Indian products with payment integration &amp; product catalog.</p>
                                        <div className="tech-tags"><span className="tech-tag">E-Commerce</span><span className="tech-tag">UI/UX</span><span className="tech-tag">Payment Gateway</span></div>
                                    </div>
                                </div>
                                <div className="proj-card mx-1">
                                    <div className="proj-img">
                                        <span className="proj-cat">Food &amp; Resto</span>
                                        <img src="img/projects/allaboutfood.jpg" alt="All About Foods" />
                                        <div className="proj-overlay"><a href="http://www.allaboutfoods.in" target="_blank" rel="noreferrer"><i className="fa fa-external-link-alt"></i> Visit Site</a></div>
                                    </div>
                                    <div className="proj-body">
                                        <h4>All About Foods</h4>
                                        <p>Restaurant website with menu management, SEO &amp; mobile-first responsive design.</p>
                                        <div className="tech-tags"><span className="tech-tag">Website</span><span className="tech-tag">SEO</span><span className="tech-tag">Responsive</span></div>
                                    </div>
                                </div>
                                <div className="proj-card mx-1">
                                    <div className="proj-img">
                                        <span className="proj-cat">Corporate</span>
                                        <img src="img/projects/MSPL.jpg" alt="MSPL" />
                                        <div className="proj-overlay"><a href="https://mspl-v0-1.vercel.app/" target="_blank" rel="noreferrer"><i className="fa fa-external-link-alt"></i> Visit Site</a></div>
                                    </div>
                                    <div className="proj-body">
                                        <h4>MSPL</h4>
                                        <p>Corporate website for a manufacturing firm with clean professional design.</p>
                                        <div className="tech-tags"><span className="tech-tag">Corporate</span><span className="tech-tag">Web Design</span><span className="tech-tag">Branding</span></div>
                                    </div>
                                </div>
                                <div className="proj-card mx-1">
                                    <div className="proj-img">
                                        <span className="proj-cat">Tech Services</span>
                                        <img src="img/projects/PCreviver.jpg" alt="PC Reviver" />
                                        <div className="proj-overlay"><a href="https://www.pcreviver.in" target="_blank" rel="noreferrer"><i className="fa fa-external-link-alt"></i> Visit Site</a></div>
                                    </div>
                                    <div className="proj-body">
                                        <h4>PC Reviver</h4>
                                        <p>Tech repair service website with booking flow &amp; local SEO for Thane region.</p>
                                        <div className="tech-tags"><span className="tech-tag">Service Site</span><span className="tech-tag">Local SEO</span><span className="tech-tag">Booking</span></div>
                                    </div>
                                </div>
                                <div className="proj-card mx-1">
                                    <div className="proj-img">
                                        <span className="proj-cat">E-Commerce</span>
                                        <img src="img/projects/Grabit.png" alt="iGRABiT" />
                                        <div className="proj-overlay"><a href="http://www.igrabit.store" target="_blank" rel="noreferrer"><i className="fa fa-external-link-alt"></i> Visit Site</a></div>
                                    </div>
                                    <div className="proj-body">
                                        <h4>iGRABiT</h4>
                                        <p>Online store with category management, cart system &amp; mobile-first design.</p>
                                        <div className="tech-tags"><span className="tech-tag">E-Commerce</span><span className="tech-tag">Mobile-First</span><span className="tech-tag">UI/UX</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>{/* /pane-projects */}

                    {/* ════════════════════════════════════════
                   PANE 2 – SMM & GROWTH
              ════════════════════════════════════════ */}
                    <div id="pane-smm" className="sec-pane">
                        <div className="smm-banner">
                            <div className="sb-text">
                                <span style={{ background: 'rgba(59,143,207,0.2)', color: 'var(--wb-secondary)', fontSize: '0.7rem', fontWeight: '700', letterSpacing: '1.5px', textTransform: 'uppercase', padding: '5px 14px', borderRadius: '50px' }}>Social Media Marketing</span>
                                <h3 className="mt-3">We Grow Brands<br />on Social Media</h3>
                                <p>From zero to a thriving community — content strategy, reels production, paid ads &amp; analytics. We've helped brands achieve 3x follower growth and 5x engagement in under 6 months.</p>
                            </div>
                            <div className="smm-grid">
                                <div className="smm-stat"><div className="sn">3x</div><div className="sl">Follower Growth</div></div>
                                <div className="smm-stat"><div className="sn">5x</div><div className="sl">Engagement</div></div>
                                <div className="smm-stat"><div className="sn">20+</div><div className="sl">Brands Managed</div></div>
                                <div className="smm-stat"><div className="sn">30+</div><div className="sl">Posts / Month</div></div>
                            </div>
                        </div>
                        <div className="row g-4">
                            <div className="col-md-4">
                                <div className="smm-card">
                                    <div className="sc-icon" style={{ background: '#fce4ec', color: '#E1306C' }}><i className="fab fa-instagram"></i></div>
                                    <h5>Instagram Management</h5>
                                    <p>Content calendar, reels, stories &amp; engagement strategy for consistent growth.</p>
                                    <div className="tech-tags mt-3"><span className="tech-tag">Reels</span><span className="tech-tag">Stories</span><span className="tech-tag">Content Calendar</span></div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="smm-card">
                                    <div className="sc-icon" style={{ background: '#e8f0fe', color: '#1877F2' }}><i className="fab fa-facebook-f"></i></div>
                                    <h5>Facebook Ads &amp; Pages</h5>
                                    <p>Targeted ad campaigns, page management &amp; lead generation funnels for local &amp; national brands.</p>
                                    <div className="tech-tags mt-3"><span className="tech-tag">Paid Ads</span><span className="tech-tag">Lead Gen</span><span className="tech-tag">Analytics</span></div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="smm-card">
                                    <div className="sc-icon" style={{ background: '#ffebee', color: '#FF0000' }}><i className="fab fa-youtube"></i></div>
                                    <h5>YouTube SEO &amp; Growth</h5>
                                    <p>Channel optimization, thumbnail design &amp; tag strategy for maximum YouTube visibility.</p>
                                    <div className="tech-tags mt-3"><span className="tech-tag">SEO</span><span className="tech-tag">Thumbnails</span><span className="tech-tag">Channel Audit</span></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ════════════════════════════════════════
                   PANE 3 – VIDEO EDITS
              ════════════════════════════════════════ */}
                    <div id="pane-videos" className="sec-pane">
                        <div className="smm-banner mb-4" style={{ gap: '20px' }}>
                            <div style={{ width: '54px', height: '54px', background: 'rgba(59,143,207,0.2)', border: '1px solid rgba(59,143,207,0.3)', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: '0' }}><i className="fa fa-film" style={{ color: 'var(--wb-secondary)', fontSize: '1.3rem' }}></i></div>
                            <div>
                                <h3 style={{ margin: '0 0 6px' }}>Professional Video Editing</h3>
                                <p>Reels, promos, ad creatives &amp; testimonials that stop the scroll and convert viewers into customers.</p>
                            </div>
                        </div>
                        <div className="row g-4">
                            <div className="col-md-4">
                                <div className="vid-card">
                                    <div className="ratio ratio-16x9"><iframe src="https://www.youtube.com/embed/VIDEO_ID_1" title="Video Edit 1" allowFullScreen></iframe></div>
                                    <div className="vid-title">Brand Promo Reel</div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="vid-card">
                                    <div className="ratio ratio-16x9"><iframe src="https://www.youtube.com/embed/VIDEO_ID_2" title="Video Edit 2" allowFullScreen></iframe></div>
                                    <div className="vid-title">Instagram Reel Edit</div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="vid-coming">
                                    <div className="text-center">
                                        <i className="fa fa-plus-circle d-block mb-2" style={{ fontSize: '2rem', color: 'var(--wb-border)' }}></i>
                                        <p style={{ color: 'var(--wb-muted)', fontSize: '0.8rem', margin: '0' }}>More videos coming soon</p>
                                    </div>
                                </div>
                                <div className="vid-title" style={{ color: 'var(--wb-muted)' }}>Coming Soon</div>
                            </div>
                        </div>
                    </div>

                    {/* ════════════════════════════════════════
                   PANE 4 – TESTIMONIALS
              ════════════════════════════════════════ */}
                    <div id="pane-testimonials" className="sec-pane">
                        <div className="smm-banner mb-4" style={{ gap: '20px' }}>
                            <div style={{ width: '54px', height: '54px', background: 'rgba(59,143,207,0.2)', border: '1px solid rgba(59,143,207,0.3)', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: '0' }}><i className="fa fa-star" style={{ color: 'var(--wb-secondary)', fontSize: '1.3rem' }}></i></div>
                            <div>
                                <h3 style={{ margin: '0 0 6px' }}>What Our Clients Say</h3>
                                <p>Real feedback from real clients. Watch their experiences working with WebBears.</p>
                            </div>
                        </div>
                        <div className="row g-4">
                            <div className="col-md-4">
                                <div className="vid-card">
                                    <div className="ratio ratio-16x9"><iframe src="https://www.youtube.com/embed/TESTIMONIAL_ID_1" title="Testimonial 1" allowFullScreen></iframe></div>
                                    <div className="vid-title">Client – BharatiyaBazaar</div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="vid-card">
                                    <div className="ratio ratio-16x9"><iframe src="https://www.youtube.com/embed/TESTIMONIAL_ID_2" title="Testimonial 2" allowFullScreen></iframe></div>
                                    <div className="vid-title">Client – PC Reviver</div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="vid-coming">
                                    <div className="text-center">
                                        <i className="fa fa-plus-circle d-block mb-2" style={{ fontSize: '2rem', color: 'var(--wb-border)' }}></i>
                                        <p style={{ color: 'var(--wb-muted)', fontSize: '0.8rem', margin: '0' }}>More coming soon</p>
                                    </div>
                                </div>
                                <div className="vid-title" style={{ color: 'var(--wb-muted)' }}>Coming Soon</div>
                            </div>
                        </div>
                    </div>

                    {/* ════════════════════════════════════════
                   PANE 5 – GALLERY
              ════════════════════════════════════════ */}
                    <div id="pane-gallery" className="sec-pane">
                        <div className="row g-3">
                            <div className="col-md-4 col-6">
                                <div className="gal-item"><img src="img/gallery/photo1.jpg" alt="Gallery 1" /><div className="gal-over"><span>Behind the Scenes</span></div></div>
                            </div>
                            <div className="col-md-4 col-6">
                                <div className="gal-item"><img src="img/gallery/photo2.jpg" alt="Gallery 2" /><div className="gal-over"><span>Team at Work</span></div></div>
                            </div>
                            <div className="col-md-4 col-6">
                                <div className="gal-item" style={{ background: 'var(--wb-light)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <div className="text-center p-3">
                                        <i className="fa fa-camera d-block mb-2" style={{ fontSize: '2rem', color: 'var(--wb-border)' }}></i>
                                        <p style={{ color: 'var(--wb-muted)', fontSize: '0.78rem', margin: '0' }}>More photos soon</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ── CTA BAND ─────────────────────────── */}
                    <div className="cta-band wow fadeInUp" data-wow-delay="0.1s">
                        <div>
                            <h3>Ready to Start Your Project?</h3>
                            <p>Let's talk about what WebBears can build for you.</p>
                        </div>
                        <a href="/contact" className="btn-cta">Get a Free Quote →</a>
                    </div>

                </div>
            </div>
            {/* ══ END MAIN CONTENT ══ */}

            <Footer />
        </>
    );
};

export default Projects;
